import React from 'react';
import PropTypes from 'prop-types';

const ListIcon = props => {
  const { color: _color, width: _width, height: _height, ...other } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14.594" height="9.47" viewBox="0 0 14.594 9.47">
      <g id="グループ_3909" data-name="グループ 3909" transform="translate(0 0)" {...other}>
        <line id="線_27" data-name="線 27" x2="9.336" transform="translate(4.633 1.107)" fill="none" stroke="#d4d5d7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <line id="線_28" data-name="線 28" x2="9.336" transform="translate(4.633 4.735)" fill="none" stroke="#d4d5d7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <line id="線_29" data-name="線 29" x2="9.336" transform="translate(4.633 8.363)" fill="none" stroke="#d4d5d7" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
        <path id="パス_3652" data-name="パス 3652" d="M2.214,1.107A1.107,1.107,0,1,1,1.107,0,1.107,1.107,0,0,1,2.214,1.107" transform="translate(0 0)" fill="#71737c" />
        <path id="パス_3653" data-name="パス 3653" d="M2.214,3.946A1.107,1.107,0,1,1,1.107,2.839,1.107,1.107,0,0,1,2.214,3.946" transform="translate(0 0.79)" fill="#71737c" />
        <path id="パス_3654" data-name="パス 3654" d="M2.214,6.784A1.107,1.107,0,1,1,1.107,5.677,1.107,1.107,0,0,1,2.214,6.784" transform="translate(0 1.579)" fill="#71737c" />
      </g>
    </svg>
  );
}

ListIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

ListIcon.defaultProps = {
  color: '#000000',
  width: 22,
  height: 22,
};

export default ListIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/ListIcon.jsx